const MAX_TRIGGERED = 50;

const initialState = {
  arrAlertsData: [],     // active alerts (from GET /api/v1/alerts)
  triggeredAlerts: [],   // triggered alerts (from GET /api/v1/updates?type=alert)
  unseenCount: 0,
  error: null,
  // Modal state — driven from Redux so the modal lives at App-level and
  // can't be unmounted by the watchlist row/drawer that triggered it.
  modal: {
    open: false,
    instrument: null,    // { token, exchange, trading_symbol, display_name, price_precision, ltp }
    isModify: false,
    existingAlert: null,
  },
};

const dedupeById = (arr) => {
  const map = new Map();
  arr.forEach((a) => {
    if (a && (a.id || a.alert_id)) map.set(a.id || a.alert_id, a);
  });
  return Array.from(map.values());
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ALERTS":
      return {
        ...state,
        arrAlertsData: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      };

    case "SET_ALERTS_ERROR_MESSAGE":
      return { ...state, error: action.payload };

    case "SET_TRIGGERED_ALERTS": {
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      const merged = dedupeById([...incoming, ...state.triggeredAlerts])
        .sort((a, b) => {
          const at = a.update_entry_time || a.generated_at || 0;
          const bt = b.update_entry_time || b.generated_at || 0;
          return new Date(bt).getTime() - new Date(at).getTime();
        })
        .slice(0, MAX_TRIGGERED);
      return { ...state, triggeredAlerts: merged };
    }

    case "ADD_TRIGGERED_ALERT": {
      const a = action.payload;
      if (!a) return state;
      const merged = dedupeById([a, ...state.triggeredAlerts]).slice(0, MAX_TRIGGERED);
      return { ...state, triggeredAlerts: merged };
    }

    case "SET_UNSEEN_ALERTS":
      return { ...state, unseenCount: Number(action.payload) || 0 };

    case "INCREMENT_UNSEEN_ALERTS":
      return { ...state, unseenCount: state.unseenCount + 1 };

    case "RESET_UNSEEN_ALERTS":
      return { ...state, unseenCount: 0 };

    case "OPEN_PRICE_ALERT_MODAL":
      return {
        ...state,
        modal: {
          open: true,
          instrument: action.payload?.instrument || null,
          isModify: !!action.payload?.isModify,
          existingAlert: action.payload?.existingAlert || null,
        },
      };

    case "CLOSE_PRICE_ALERT_MODAL":
      return {
        ...state,
        modal: { open: false, instrument: null, isModify: false, existingAlert: null },
      };

    default:
      return state;
  }
}
